export const TOAST_TYPE_WARN = 'warn'
export const TOAST_TYPE_INFO = 'info'
export const TOAST_TYPE_ERROR = 'error'
export const TOAST_TYPE_SUCCESS = 'success'
